// Claude: alpha-tester feedback — "Debug output is left in the console" on the live site. The
// Claude: console.log calls that leaked tokens/role/username or a component's source were removed
// Claude: outright; the many remaining development traces are silenced in production builds only
// Claude: (`npm run build` sets NODE_ENV=production), so local `npm start` still shows them.
// Claude: console.warn/console.error are left alone so genuine problems still surface. Takes env and
// Claude: the console object as parameters so it is unit-testable (see silenceConsole.test.js).
export function silenceConsoleInProduction(env, consoleObj) {
  if (env.NODE_ENV === "production") {
    consoleObj.log = () => {};
    consoleObj.debug = () => {};
    consoleObj.info = () => {};
  }
}
